import { QuoteQuestionUtils } from "Helpers";
import { useMapContext } from "Plugins/FloorPlan/Context/MapContext";
import { useIsMobile } from "Web/Context/PlatformContext/PlatformContext";
import { Scroller, useScroller } from "Web/Pages/Quote/Helpers/Scroller";

export const useQuestionScroller = () => {
    const map = useMapContext();
    const scroller = useScroller();
    const isMobile = useIsMobile();

    const openProduitPrincipal = (roomId: string, questionId: string) => {
        map.setPanel({
            values: {
                selectedRoomId: roomId,
                rooms: map.state.rooms?.map((x) =>
                    x.roomId === roomId ? { ...x, openSections: { questionsProduit: true } } : x
                ),
            },
            afterUpdate: () => {
                setTimeout(() => {
                    scroller.scrollToDiv(Scroller.ID, QuoteQuestionUtils.toQuestionItemId(roomId, questionId), isMobile);
                }, Scroller.ShortDelay);
            },
        });
    }

    const openProduitSecondaire = (roomId: string, questionId: string) => {
        map.setPanel({
            values: {
                selectedRoomId: roomId,
                rooms: map.state.rooms?.map((x) =>
                    x.roomId === roomId ? { ...x, openSections: { questionsPose: true } } : x
                ),
            },
            afterUpdate: () => {
                setTimeout(() => {
                    scroller.scrollToDiv(Scroller.ID, QuoteQuestionUtils.toQuestionItemId(roomId, questionId), isMobile);
                }, Scroller.ShortDelay);
            },
        });
    }
    return { openProduitPrincipal, openProduitSecondaire }
};